"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = exports.BLACK = exports.WHITE = void 0;
var WHITE = '#ffffff';
exports.WHITE = WHITE;
var BLACK = '#000000';
exports.BLACK = BLACK;
var colors = {
  background: '#fafafa',
  common: {
    white: WHITE,
    black: BLACK,
    whiteContrastText: BLACK,
    blackContrastText: WHITE
  },
  gray: {
    '50': getGrayColor(0.95),
    '100': getGrayColor(0.9),
    '200': getGrayColor(0.8),
    '300': getGrayColor(0.7),
    '400': getGrayColor(0.6),
    '500': getGrayColor(0.5),
    '600': getGrayColor(0.4),
    '700': getGrayColor(0.3),
    '800': getGrayColor(0.2),
    '900': getGrayColor(0.1)
  },
  blackOpacity: {
    '50': getBlackOpacityColor(0.05),
    '100': getBlackOpacityColor(0.1),
    '200': getBlackOpacityColor(0.2),
    '300': getBlackOpacityColor(0.3),
    '400': getBlackOpacityColor(0.4),
    '500': getBlackOpacityColor(0.5),
    '600': getBlackOpacityColor(0.6),
    '700': getBlackOpacityColor(0.7),
    '800': getBlackOpacityColor(0.8),
    '900': getBlackOpacityColor(0.9)
  },
  whiteOpacity: {
    '50': getWhiteOpacityColor(0.05),
    '100': getWhiteOpacityColor(0.1),
    '200': getWhiteOpacityColor(0.2),
    '300': getWhiteOpacityColor(0.3),
    '400': getWhiteOpacityColor(0.4),
    '500': getWhiteOpacityColor(0.5),
    '600': getWhiteOpacityColor(0.6),
    '700': getWhiteOpacityColor(0.7),
    '800': getWhiteOpacityColor(0.8),
    '900': getWhiteOpacityColor(0.9)
  },
  borders: {
    main: "".concat(BLACK).concat(getHexByte(0.25)),
    light: "".concat(BLACK).concat(getHexByte(0.1))
  },
  text: {
    main: BLACK,
    info: "".concat(BLACK).concat(getHexByte(0.5))
  },
  brand: {
    lightest: '#EBE7FF',
    light: '#D6CEFF',
    main: '#6A50F2',
    dark: '#4129BD',
    darkest: '#281683',
    contrastText: WHITE,
    contrastTextLight: BLACK
  },
  positive: {
    lightest: '#DFF6E6',
    light: '#BBECCB',
    main: '#38C765',
    dark: '#2FB85A',
    darkest: '#108B36',
    contrastText: WHITE,
    contrastTextLight: BLACK
  },
  negative: {
    lightest: '#FFE7E5',
    light: '#FFCFCC',
    main: '#F21D0D',
    dark: '#CA271B',
    darkest: '#871A12',
    contrastText: WHITE,
    contrastTextLight: BLACK
  },
  neutral: {
    lightest: '#FCF5DB',
    light: '#FFEB9E',
    main: '#FFDD5B',
    dark: '#EDC52A',
    darkest: '#D6AC0B',
    contrastText: WHITE,
    contrastTextLight: BLACK
  }
};
/**
 * Get hex color byte (e.g. to get transparency)
 * @param value Percentage value (between 0.0 and 1.0)
 */

exports.colors = colors;

function getHexByte(value) {
  return (Math.round(255 * value / 16) * 16).toString(16);
}

function getGrayColor(value) {
  return "#".concat(getHexByte(value)).concat(getHexByte(value)).concat(getHexByte(value));
}

function getBlackOpacityColor(value) {
  return "rgba(0,0,0,".concat(value, ")");
}

function getWhiteOpacityColor(value) {
  return "rgba(255,255,255,".concat(value, ")");
}